import { render, staticRenderFns } from "./VerificationPieChart.vue?vue&type=template&id=6b455cd5"
import script from "./VerificationPieChart.vue?vue&type=script&lang=js"
export * from "./VerificationPieChart.vue?vue&type=script&lang=js"
import style0 from "./VerificationPieChart.vue?vue&type=style&index=0&id=6b455cd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports